import styled from "styled-components";
import { unitizedPx, BADI_COLORS } from "@badi/badi-components";

export const Root = styled.div`
  position: relative;
  min-width: ${unitizedPx(19)};
  padding-left: ${unitizedPx(1)};

  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;

    height: 100%;
    width: 0px;
    border-left: 2px solid ${BADI_COLORS.SEMANTIC.INFO.DEFAULT};
  }
`;
